export const iconFontAwesomeAccessibilityEarListen = (
	<i className="fa-solid fa-ear-listen"></i>
);
